import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserList } from '../_models';
import { DesignVersionEnum } from '../_enums/design-version.enum';

@Injectable()
export class DataService {

  private publicKey = new BehaviorSubject('default Key');
  currentPublicKey = this.publicKey.asObservable();

  private invoicePublicKey = new BehaviorSubject('invoice Key');
  currentInvoicePublicKey = this.invoicePublicKey.asObservable();

  private debtorPublicKey = new BehaviorSubject('debtor Key');
  currentDebtorPublicKey = this.debtorPublicKey.asObservable();

  private chartDataInvoice = new BehaviorSubject([]);
  currentChartDataInvoice = this.chartDataInvoice.asObservable();

  private chartDataPayment = new BehaviorSubject([]);
  currentChartDataPayment = this.chartDataPayment.asObservable();


  private userProfilePhoto = new BehaviorSubject('');
  currentUserProfilePhoto = this.userProfilePhoto.asObservable();

  private userProfileName = new BehaviorSubject('');
  currentUserProfileName = this.userProfileName.asObservable();


  private chartIsLoading = new BehaviorSubject('');
  currentChartIsLoading = this.chartIsLoading.asObservable();

  private designVersionSubject = new BehaviorSubject<'' | 'V1' | 'V2'>('');
  designVersion$ = this.designVersionSubject.asObservable();

  private collapsedMenuSubject = new BehaviorSubject<boolean>(false);
  collapsedMenuSubject$ = this.collapsedMenuSubject.asObservable();

  private loadSpinnerSubject = new BehaviorSubject<boolean>(false);
  loadSpinnerSubject$ = this.loadSpinnerSubject.asObservable();

  private reloadUsersSubject : Subject<UserList[]> = new Subject<UserList[]>();
  reloadUsersSubject$ = this.reloadUsersSubject.asObservable();

  private displayTemplateSectionSubject = new BehaviorSubject<'LIST' | 'CREATE-FORM' |'EDIT-DUPLICATE-FORM'>('LIST');
  displayTemplateSectionSubject$ = this.displayTemplateSectionSubject.asObservable();

  private hideHeaderSubject = new BehaviorSubject<boolean>(false);
  hideHeader$ = this.hideHeaderSubject.asObservable();

  constructor() {
    this.setDesignVersion();
  }

  setDesignVersion() {
    this.designVersionSubject.next(DesignVersionEnum.designVersionDefault);
    localStorage.setItem('designVersion', DesignVersionEnum.designVersionDefault);
    const collapsedMenuLocalStorageValue = JSON.parse(localStorage.getItem('statusMenu'));
    if (collapsedMenuLocalStorageValue && [true, false].includes(collapsedMenuLocalStorageValue)) {
      this.collapsedMenuSubject.next(collapsedMenuLocalStorageValue as boolean);
    }
  }

  changepublicKey(pKey: string) {
    this.publicKey.next(pKey)
  }

  changeinvoicepublicKey(pKey: string) {
    this.invoicePublicKey.next(pKey)
  }

  changedebtorpublicKey(pKey: string) {
    this.debtorPublicKey.next(pKey)
  }


  changechartdatainvoice(value: any) {
    this.chartDataInvoice.next(value)
  }

  changechartdatapayment(value: any) {
    this.chartDataPayment.next(value)
  }


  changeuserprofilephoto(value: any) {
    this.userProfilePhoto.next(value)
  }


  changeuserprofilename(value: any) {
    this.userProfileName.next(value)
  }
  changechartisloading(value: any) {
    this.chartIsLoading.next(value)
  }

  designVersion(value: 'V1' | 'V2') {
    this.designVersionSubject.next(DesignVersionEnum.designVersionDefault);
    localStorage.setItem('designVersion', DesignVersionEnum.designVersionDefault);
  }

  menuStatus(value: boolean) {
    this.collapsedMenuSubject.next(value);
    localStorage.setItem('statusMenu', JSON.stringify(value));
  }

  loadSpinner(value: boolean) {
    this.loadSpinnerSubject.next(value);
  }

  reloadCustomerUsersList(value: UserList[]) {
    this.reloadUsersSubject.next(value);
  }

  displayTemplateSection(value: 'LIST' | 'CREATE-FORM' | 'EDIT-DUPLICATE-FORM') {
    this.displayTemplateSectionSubject.next(value);
  }

  hideHeader(value: boolean) {
    this.hideHeaderSubject.next(value);
  }

}
